import script from "./cardDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./cardDesktop.vue?vue&type=script&setup=true&lang=js"

import "./cardDesktop.vue?vue&type=style&index=0&id=65c65b50&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c65b50"]])

export default __exports__